import { render } from '@wordpress/element';
import App from './App';

// Ищем div, который мы генерируем через шорткод в PHP
const rootElement = document.getElementById('tsr-react-app');
if (rootElement) {
    render(<App />, rootElement);
}